/** Prints the provided HTML from a new tab, then closes that tab once printing finishes */
export default function printHTML(html: string) {
	// Open new tab with the content
	const newTabWindow = window.open();
	newTabWindow?.document.write(html);
	newTabWindow?.document.close();
	newTabWindow?.focus();
	
	
	// Close the tab after printing
	newTabWindow?.addEventListener(
		'afterprint',
		() => {
			newTabWindow?.close();
		},
		{ once: true }
	);
	
	
	// Print
	newTabWindow?.print();
}
